export const getCurrentMonthJapanese = () => {
    const date = new Date();
    const monthNumber = date.getMonth() + 1;

    // Convert to full-width numerals
    const fullWidthMonthNumber = String(monthNumber).split('').map(digit =>
        String.fromCharCode(digit.charCodeAt(0) + 0xFEE0)
    ).join('');

    return `${fullWidthMonthNumber}月`;
};
